export const questionsForm = [
    {
        id: 'prothese_douloureuse',
        title: 'Prothèse Douloureuse',
        questions: [
            {
                id: 'incision_cutanee',
                label: 'Incision cutanée',
                type: 'checkbox',
                options: [
                    "médiale",
                    "médiane",
                    "latérale",
                ],
                other: true
            },
            {
                id: 'osteotomie_tuberosite_tibiale',
                label: 'Ostéotomie de la tubérosité tibiale',
                type: 'boolean',
            },
            {
                id: 'voie_abord',
                label: 'Voie d’abord',
                type: 'checkbox',
                options: [
                    "médiale para patellaire",
                    "médiale mid-vastus",
                    "médiale subvastus",
                    "latérale para patellaire",
                    "latérale subvastus",
                    "Minimal invasive épargne quadriceps",
                    "Minimal invasif midvastus",
                    "Minimal invasif subvastus",
                ],
                other: true
            }
        ]
    },
    {
        id: 'type_prothese',
        title: 'Type de prothèse',
        questions: [
            {
                id: 'type_total',
                label: 'Type total',
                type: 'checkbox',
                options: [
                    "Fémur cimenté",
                    "Fémur non cimenté",
                    "Tibia cimenté",
                    "Tibia non cimenté",
                    "Rotule resurfacée",
                    "Quille fémorale",
                    "Quille tibiale",
                    "Cônes",
                    "Sleaves",
                    "Câles"
                ],
            },
            {
                id: 'type_total-precision',
                label: 'Précisions',
                type: 'textarea',
            },
            {
                id: 'type_unicompartimentale',
                label: 'Type unicompartimentale',
                type: 'checkbox',
                options: [
                    "Fémur cimenté",
                    "Fémur non cimenté",
                    "Tibia cimenté",
                    "Tibia non cimenté"
                ],
            },
            {
                id: 'type_unicompartimentale-precision',
                label: 'Précisions',
                type: 'textarea',
            },
            {
                id: 'type_femoro_patellaire',
                label: 'Type fémoro-patellaire',
                type: 'checkbox',
                options: [
                    "Rotule cimentée",
                    "Fémur cimenté",
                    "Rotule non cimentée",
                    "Fémur non cimenté"
                ],
            },
            {
                id: 'type_femoro_patellaire-precision',
                label: 'Précisions',
                type: 'textarea',
            },
        ]
    },
    {
        id: 'question_concernant_genou_problematique',
        title: 'Question concernant le genou problématique',
        questions: [
            {
                id: 'probleme_principal',
                label: 'Problème principal',
                type: 'checkbox',
                options: [
                    "Douleur",
                    "Instabilité",
                    "Gonflement",
                    "Raideur"
                ],
                other: true
            },
        ],
    },
    {
        id: 'douleur',
        title: 'Douleur',
        questions: [
            {
                id: 'douleur_avant_chirurgie',
                label: 'Douleur avant Arthroplastie Totale du Genou, Arthroplastie Unicompartimentale du Genou ou Arthroplastie Fémoro-Patellaire',
                type: 'textarea',
            },
            {
                id: 'sans_douleur_apres_chirurgie',
                label: 'Période sans douleur après la chirurgie',
                type: 'boolean',
            },
            {
                id: 'sans_douleur_apres_chirurgie-precision',
                label: 'Combien de temps et quand ?',
                type: 'text',
                conditionalTo: 'sans_douleur_apres_chirurgie',
            },
            {
                id: 'douleur_actuelle',
                label: 'Douleur actuelle différente de celle avant la chirurgie ?',
                type: 'boolean',
            },
            {
                id: 'satifaction_eva',
                label: 'Satisfaction EVA (0-10)',
                type: 'slider',
                min: 0,
                max: 10,
            },
            {
                id: 'douleur_totale_eva',
                label: 'Douleur totale EVA (0-10)',
                type: 'slider',
                min: 0,
                max: 10,
            },
            {
                id: 'caractere_douleur',
                label: 'Caractère de la douleur',
                type: 'checkbox',
                options: [
                    "sourde",
                    "pulsatile",
                    "brulante",
                    "électrisante",
                    "lancinante",
                    "vive",
                    "crampe"
                ],
            },
            {
                id: 'douleur_persistante',
                label: 'Douleur persistante',
                type: 'boolean',
            },
            {
                id: 'hyperalgesie_generale',
                label: 'Hyperalgésie générale',
                type: 'boolean',
            },
            {
                id: 'douleur_en_charge',
                label: 'Douleur en charge',
                type: 'boolean',
            },
            {
                id: 'douleur_en_charge-precision',
                label: 'EVA (0-10)',
                type: 'slider',
                conditionalTo: 'douleur_en_charge',
                min: 0,
                max: 10,
            },
            {
                id: 'douleur_poussee_pied_marchant',
                label: 'Douleur lors de la poussée du pied en marchant',
                type: 'boolean',
            },
            {
                id: 'douleur_poussee_pied_marchant-precision',
                label: 'EVA (0-10)',
                type: 'slider',
                conditionalTo: 'douleur_poussee_pied_marchant',
                min: 0,
                max: 10,
            },
            {
                id: 'douleur_repos',
                label: 'Douleur au repos',
                type: 'boolean',
            },
            {
                id: 'douleur_repos-precision',
                label: 'EVA (0-10)',
                type: 'slider',
                conditionalTo: 'douleur_repos',
                min: 0,
                max: 10,
            },
            {
                id: 'douleur_nuit',
                label: 'Douleur la nuit',
                type: 'boolean',
            },
            {
                id: 'douleur_nuit-precision',
                label: 'EVA (0-10)',
                type: 'slider',
                conditionalTo: 'douleur_nuit',
                min: 0,
                max: 10,
            },
            {
                id: 'facteurs_declenchants',
                label: 'Facteurs déclenchants',
                type: 'textarea',
            },
            {
                id: 'facteurs_attenuants',
                label: 'Facteurs atténuants',
                type: 'textarea',
            },
            {
                id: 'localisation',
                label: 'Localisation',
                type: 'label',
            },
            {
                id: 'localisation_medial',
                label: 'Médial',
                type: 'text'
            },
            {
                id: 'localisation_lateral',
                label: 'Latéral',
                type: 'text'
            },
            {
                id: 'localisation_anterieur',
                label: 'Antérieur',
                type: 'text'
            },
            {
                id: 'localisation_posterieur',
                label: 'Postérieur',
                type: 'text'
            },
            {
                id: 'douleur_irradiante',
                label: 'Douleur irradiante',
                type: 'checkbox',
                options: [
                    "Fémur Médial",
                    'Fémur Latéral',
                    'Fémur Médian',
                    'Tibia Médial',
                    'Tibia Latéral',
                    "Tibia Coussinet adipeux de Hoffa",
                ],
            },
            {
                id: 'douleur_irradiante_depuis',
                label: 'Douleur irradiante depuis',
                type: 'checkbox',
                options: [
                    "Colonne lombaire",
                    "Hanche",
                ],
            }
        ]
    },
    {
        id: 'medicaments',
        title: 'Médicaments',
        questions: [
            {
                id: 'medicaments_douleur',
                label: 'Médicaments contre la douleur',
                type: 'checkbox',
                options: [
                    "AINS (Anti-Inflammatoires non stéroïdiens)",
                    "Morphine",
                    "Paracétamol",
                ],
                other: true
            },
            {
                id: 'antidepresseurs',
                label: 'Antidépresseurs',
                type: 'textarea',
            },
            {
                id: 'anticoagulants',
                label: 'Anticoagulants',
                type: 'checkbox',
                options: [
                    "Coumarine/Warfarine",
                    "Aspirine",
                    "Clopidogrel",
                ],
                other: true
            },
            {
                id: 'autres_diagnostiques_medicaux',
                label: 'Autres diagnostiques médicaux',
                type: 'multiple',
            },
        ]
    },
    {
        id: "suivi_postoperatoire",
        title: "Suivi postopératoire",
        questions: [
            {
                id: "mobilisation_sous_narcose",
                label: "Mobilisation sous narcose",
                type: "boolean"
            },
            {
                id: "mobilisation_arthroscopique",
                label: "Mobilisation arthroscopique",
                type: "boolean"
            },
            {
                id: "problemes_de_cicatrisation_des_plaies",
                label: "Problèmes de cicatrisation des plaies",
                type: "boolean"
            },
            {
                id: "antibiotiques_necessaires",
                label: "Antibiotiques nécessaires",
                type: "boolean",
            },
            {
                id: 'antibiotiques_necessaires-precision',
                label: 'Lesquels ?',
                type: 'textarea',
                conditionalTo: 'antibiotiques_necessaires',
            },
            {
                id: "reoperation",
                label: "Réopération",
                type: "boolean",
            },
            {
                id: 'reoperation-precision',
                label: 'Laquelle ?',
                type: 'textarea',
                conditionalTo: 'reoperation',
            },
        ]
    },
    {
        id: "examen_clinique",
        title: 'Examen clinique',
        questions: [
            {
                id: "mobilisation",
                label: 'Mobilisation',
                type: 'radio',
                options: [
                    "1 béquille",
                    "2 béquilles",
                    "fauteuil roulant",
                ],
            },
            {
                id: "demarche_boiteuse",
                label: 'Démarche boiteuse',
                type: 'boolean',
            },
            {
                id: "affaiblissement_de_l_appareil_extenseur",
                label: 'Affaiblissement de l’appareil extenseur',
                type: 'boolean',
            },
            {
                id: "alignement_du_membre",
                label: 'Alignement du membre',
                type: 'radio',
                options: [
                    "Neutre",
                    "Varus",
                    "Valgus",
                ],
            },
            {
                id: "rotation_du_pied",
                label: 'Rotation du pied',
                type: 'radio',
                options: [
                    "Normale",
                    "Rotation interne",
                    "Rotation externe",
                ],
            },
            {
                id: "deviation_en_varus_de_l_orteil",
                label: 'Déviation en varus de l’orteil',
                type: 'boolean',
            },
            {
                id: "deviation_en_varus_du_talon",
                label: 'Déviation en varus du talon',
                type: 'boolean',
            },
            {
                id: "possibilite_de_s_agenouiller",
                label: 'Possibilité de s’agenouiller',
                type: 'boolean',
            },
            {
                id: "possibilite_de_s_accroupir",
                label: 'Possibilité de s’accroupir',
                type: 'boolean',
            }
        ]
    },
    {
        id: "incision_cutanees_cicatrices",
        title: 'Incision cutanées / cicatrices',
        questions: [
            {
                id: "erytheme",
                label: 'Erythème',
                type: 'boolean',
            },
            {
                id: 'erytheme_medial-precision',
                label: 'Médial',
                type: 'text',
                conditionalTo: 'erytheme',
            },
            {
                id: 'erytheme_lateral-precision',
                label: 'Latéral',
                type: 'text',
                conditionalTo: 'erytheme',
            },
            {
                id: 'erytheme_anterieur-precision',
                label: 'Antérieur',
                type: 'text',
                conditionalTo: 'erytheme',
            },
            {
                id: 'erytheme_posterieur-precision',
                label: 'Postérieur',
                type: 'text',
                conditionalTo: 'erytheme',
            },
            {
                id: "gonflement",
                label: 'Gonflement',
                type: 'boolean',
            },
            {
                id: 'gonflement_medial-precision',
                label: 'Médial',
                type: 'text',
                conditionalTo: 'gonflement',
            },
            {
                id: 'gonflement_lateral-precision',
                label: 'Latéral',
                type: 'text',
                conditionalTo: 'gonflement',
            },
            {
                id: 'gonflement_anterieur-precision',
                label: 'Antérieur',
                type: 'text',
                conditionalTo: 'gonflement',
            },
            {
                id: 'gonflement_posterieur-precision',
                label: 'Postérieur',
                type: 'text',
                conditionalTo: 'gonflement',
            },
            {
                id: "sinus",
                label: 'Sinus',
                type: 'boolean',
            },
            {
                id: 'sinus_medial-precision',
                label: 'Médial',
                type: 'text',
                conditionalTo: 'sinus',
            },
            {
                id: 'sinus_lateral-precision',
                label: 'Latéral',
                type: 'text',
                conditionalTo: 'sinus',
            },
            {
                id: 'sinus_anterieur-precision',
                label: 'Antérieur',
                type: 'text',
                conditionalTo: 'sinus',
            },
            {
                id: 'sinus_posterieur-precision',
                label: 'Postérieur',
                type: 'text',
                conditionalTo: 'sinus',
            },
            {
                id: "decoloration_de_la_peau",
                label: 'Décoloration de la peau',
                type: 'boolean',
            }
        ]
    },
    {
        id: "palpation",
        title: 'Palpation',
        questions: [
            {
                id: "sensibilite",
                label: 'Sensibilité',
                type: 'boolean',
            },
            {
                id: "sensibilite-precision",
                label: 'Où ?',
                type: 'checkbox',
                options: [
                    "Latéral parapatellaire",
                    "Interligne articulaire médial",
                    "Interligne articulaire Latéral",
                    "Patte d’oie",
                    "Proximal à la rotule",
                    "Distale à la rotule",
                    "Hoffa",
                    "Tractus iliotibial",
                ],
                conditionalTo: 'sensibilite',

            },
            {
                id: "signe_de_tinel",
                label: 'Signe de Tinel',
                type: 'boolean',
            },
            {
                id: "crepitation",
                label: 'Crépitation',
                type: 'checkbox',
                options: [
                    "Rétropatellaire",
                    "Tractus ilio-tibial",
                    "LCM",
                    "LCL",
                ],
            },
            {
                id: "rom_flexion_extension_active",
                label: 'ROM Flexion/extension active',
                type: 'text',
                mask: '##/##/##',
            },
            {
                id: "rom_flexion_extension_passive",
                label: 'ROM Flexion/extension passive',
                type: 'text',
                mask: '##/##/##',
            },
            {
                id: "rom_hyperextension",
                label: 'ROM Hyperextension',
                type: 'boolean',
            },
            {
                id: "rom_deficit_de_flexion",
                label: 'ROM Déficit de flexion',
                type: 'boolean',
            },
            {
                id: "rom_flexum",
                label: 'ROM Flexum',
                type: 'boolean',
            },
            {
                id: "rom_tracking_rotulien_normal_sinon",
                label: 'ROM Tracking rotulien normal- sinon',
                type: 'textarea',
            },
            {
                id: "problemes_de_l_articulation_de_la_hanche",
                label: 'Problèmes de l’articulation de la hanche',
                type: 'boolean'
            },
            {
                id: "problemes_de_la_colonne_lombaire",
                label: 'Problèmes de la colonne lombaire',
                type: 'boolean'
            },
        ]
    },
    {
        id: 'test_de_stabilite',
        title: 'Tests de stabilité',
        questions: [
            {
                id: "varus_valgus_extension",
                label: 'Varus-valgus en extension',
                type: 'label',
            },
            {
                id: "varus_valgus_extension_medial",
                label: 'Médial',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            },
            {
                id: "varus_valgus_extension_lateral",
                label: 'Latéral',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            },
            {
                id: "varus_valgus_flexion",
                label: 'Varus-valgus à 30° flexion',
                type: 'label',
            },
            {
                id: "varus_valgus_flexion_medial",
                label: 'Médial',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            },
            {
                id: "varus_valgus_flexion_lateral",
                label: 'Latéral',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            },
            {
                id: "instabilite_en_extension",
                label: 'Instabilité en extension',
                type: "label",
            },
            {
                id: "instabilite_en_flexion_moyenne-precision",
                label: '',
                type: 'boolean',
            },
            {
                id: "instabilite_en_flexion_moyenne",
                label: '',
                type: 'radio',
                options: [
                    "Médiale",
                    "Latérale",
                ],
            },
            {
                id: "laxite_anterieur_en_flexion_a_90_degres",
                label: 'Laxité antérieur en flexion à 90°',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            },
            {
                id: "laxite_posterieur_en_flexion_a_90_degres",
                label: 'Laxité postérieur en flexion à 90°',
                type: 'radio',
                options: [
                    "+",
                    "++",
                    "+++",
                ],
            }
        ]
    },
    {
        id: 'radiographies_avant_ptg_puc_pfp',
        title: 'Radiographies avant PTG/PUC/PFP',
        questions: [
            {
                id: "radiographies_avant_ptg_puc_pfp",
                label: 'Radiographies avant PTG/PUC/PFP',
            },
            {
                id: "deformation_en_varus",
                label: 'Déformation en varus',
                type: 'boolean',
            },
            {
                id: "deformation_en_valgus",
                label: 'Déformation en valgus',
                type: 'boolean',
            },
            {
                id: "varus_valgus_tibial_anatomique",
                label: 'Varus-valgus tibial anatomique',
                type: 'text',
            },
            {
                id: "varus_valgus_femoral_anatomique",
                label: 'Varus-valgus fémoral anatomique',
                type: 'text',
            },
            {
                id: "angle_tibiofemoral",
                label: 'Angle tibiofémoral',
                type: 'text',
            },
            {
                id: "pente_tibiale",
                label: 'Pente tibiale',
                type: 'text',
            },
            {
                id: "arthrose",
                label: 'Arthrose',
                type: 'checkbox',
                options: [
                    "Médiale",
                    "Latéral",
                    "Fémoro-patellaire",
                ],
            },
            {
                id: "classification_de_kellgren-lawrence_mediale",
                label: 'Kellgren-Lawrence (0-4) Médiale',
                type:'slider',
                min: 0,
                max: 4,
            },
            {
                id: "classification_de_kellgren-lawrence_laterale",
                label: 'Kellgren-Lawrence (0-4) Latérale',
                type:'slider',
                min: 0,
                max: 4,
            },
            {
                id: "classification_de_kellgren-lawrence_femoro-patellaire",
                label: 'Kellgren-Lawrence (0-4) Fémoro-patellaire',
                type:'slider',
                min: 0,
                max: 4,
            },
            {
                id: "osteonecrose",
                label: 'Ostéonécrose',
                type: 'boolean',
            },
            {
                id: "commentaires",
                label: 'Commentaires',
                type: 'textarea',
            },
        ]
    },
    {
        id: "radiographies_apres_ptg_puc_pfp",
        title: "Radiographies après PTG/PUC/PFP",
        questions: [
            {
                id: "tibia",
                label: "Tibia",
                type: "radio",
                options: [
                    "Varus",
                    "Valgus",
                    "Neutre"
                ]
            },
            {
                id: "pente_tibiale",
                label: "Pente tibiale",
                type: "radio",
                options: [
                    "Antérieur",
                    "Postérieur"
                ]
            },
            {
                id: "debordement_tibial",
                label: "Débordement tibial",
                type: "radio",
                options: [
                    "Médial",
                    "Latéral",
                    "Antéro-postérieur"
                ]
            },
            {
                id: "femur",
                label: "Fémur",
                type: "radio",
                options: [
                    "Varus",
                    "Valgus",
                    "Neutre",
                    "Flexion",
                    "Extension",
                    "Notch"
                ]
            },
            {
                id: "taille",
                label: "Taille",
                type: "radio",
                options: [
                    "Sous-dimensionné",
                    "Normal",
                    "Surdimensionnée"
                ]
            },
            {
                id: "patella",
                label: "Patella",
                type: "radio",
                options: [
                    "Basse",
                    "Normale",
                    "Haute"
                ]
            },
            {
                id: "surdimensionnement",
                label: "Surdimensionnement",
                type: "radio",
                options: [
                    "Antéro-postérieur",
                    "Médial",
                    "Latéral"
                ]
            },
            {
                id: "offset_posterieur_du_condyle",
                label: "Offset postérieur du condyle (mm)",
                type: "number"
            },
            {
                id: "signes_de_descellement",
                label: "Signes de descellement",
                type: "boolean"
            },
            {
                id: "pao",
                label: "PAO",
                type: "boolean"
            }
        ]
    },
    {
        id: "radiographies",
        title: 'Radiographies',
        questions: [
            {
                id: "radiographies_de_stress_fluoroscopie_par_rapport_au_cote_controlateral",
                label: 'Radiographies de stress/Fluoroscopie par rapport au côté controlatéral',
                type: "label"
            },
            {
                id: "radiographies_de_stress_fluoroscopie_en_extension_mediale",
                label: 'En extension médiale',
                type: 'text',
                mask: '##/## °'
            },
            {
                id: "radiographies_de_stress_fluoroscopie_en_extension_laterale",
                label: 'En extension latérale',
                type: 'text',
                mask: '##/## °'
            },
            {
                id: "radiographies_de_stress_fluoroscopie_en_flexion_a_30_degres_mediale",
                label: 'En flexion à 30° médiale',
                type: 'text',
                mask: '##/## °'
            },
            {
                id: "radiographies_de_stress_fluoroscopie_en_flexion_a_30_degres_laterale",
                label: 'En flexion à 30° latérale',
                type: 'text',
                mask: '##/## °'
            },
            {
                id: "radiographies_en_ap_a_90_degres",
                label: 'Radiographies en AP à 90°',
                type: 'label'
            },
            {
                id: "radiographies_en_ap_a_90_degres_translation_anterieure_en_mm",
                label: 'Translation antérieure en mm',
                type: 'text',
                mask: '##/## mm'
            },
            {
                id: "radiographies_en_ap_a_90_degres_translation_posterieure_en_mm",
                label: 'Translation postérieure en mm',
                type: 'text',
                mask: '##/## mm'
            },
            {
                id: "radiographies_en_ap_a_30",
                label: 'Radiographies en AP à 30°',
                type: 'label'
            },
            {
                id: "radiographies_en_ap_a_30_translation_anterieure_en_mm",
                label: 'Translation antérieure en mm',
                type: 'text',
                mask: '##/## mm'
            },
            {
                id: "radiographies_en_ap_a_30_translation_posterieure_en_mm",
                label: 'Translation postérieure en mm',
                type: 'text',
                mask: '##/## mm'
            },
        ]
    },
    {
        id: "99m_tchdp-spect_ct",
        title: '99m Tc-HDP-SPECT/CT',
        questions: [
            {
                id: "determination_de_la_position_des_composants_de_tka_uka_pfj_en_3d_ct",
                label: 'Détermination de la position des composants de TKA/UKA/PFJ en 3D-CT ',
                type: 'label',
            },
            {
                id: "femur_varus-valgus",
                label: 'Fémur Varus (+) / Valgus (-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "femur_flexion-extension",
                label: 'Fémur Flex(+) / Ext(-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "femur_rotation_interne-rotation_externe",
                label: 'Fémur RI(+) / RE(-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "tibia_varus-valgus",
                label: 'Tibia Varus (+) / Valgus (-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "femur_pente_ant-pente_post",
                label: 'Tibia Pente ant (+) / post(-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "tibia_rotation_interne-rotation_externe",
                label: 'Tibia RI(+) / RE(-)',
                type: 'select',
                options: [
                    "+",
                    "-",
                ],
            },
            {
                id: "composant_spect",
                label: 'Composant SPECT',
                type: 'checkbox',
                options: [
                    "Descellement fémoral",
                    "Descellement tibial",
                    "Blocage mécanique",
                    "Mauvaise position",
                    "Infection",
                    "Arthrose fémoro-patellaire",
                    "PAO",
                    "Surdimensionnement",
                    "Sous-dimensionnement",
                    "Granulome",
                ],
                other: true
            },
        ]
    },
    {
        id: "anti-leucocyte-spect_ct",
        title: 'Anti-Leucocyte-SPECT/CT',
        questions: [
            {
                id: "infection",
                label: 'Infection',
                type: 'boolean',
            },
            {
                id: "localisation",
                label: 'Remarques',
                type: 'textarea',
            },
        ]
    },
    {
        id: "analyse_de_laboratoire",
        title: 'Analyses de laboratoire',
        questions: [
            {
                id: "crp",
                label: 'CRP',
                type: 'text',
            },
            {
                id: "fsc",
                label: 'FSC',
                type: 'text',
            },
            {
                id: "vs",
                label: 'VS',
                type: 'text',
            },
            {
                id: "il-6",
                label: 'IL-6',
                type: 'text',
            },
            {
                id: "procalcitonine",
                label: 'Procalcitonin',
                type: 'text',
            },
        ]
    },
    {
        id: "ponction_articulaire",
        title: 'Ponction articulaire',
        questions: [
            {
                id: "compte_globules_blanc",
                label: 'Compte de globules blanc',
                type: 'text',
            },
            {
                id: "repartition_pmn",
                label: 'Répartition PMN',
                type: 'text',
            },
            {
                id: "gram",
                label: 'Gram +/-',
                type: 'text',
            },
            {
                id: "culture",
                label: 'Culture',
                type: 'text',
            },
        ]
    },
    {
        id: "arthroscopie",
        title: 'Arthroscopie',
        questions: [
            {
                id: "histologie",
                label: 'Histologie',
                type: 'text',
            },
            {
                id: "biopsie",
                label: 'Biopsie',
                type: 'text',
            },
            {
                id: "culture",
                label: 'Culture',
                type: 'text',
            },
        ]
    },
    {
        id: 'diagnostique',
        title: 'Diagnostique',
        questions: [
            {
                id: "diagnostique_differentiel_avant_la_chirurgie_de_revision",
                label: 'Diagnostique différentiel avant la chirurgie de révision',
                type: 'textarea',
            },
            {
                id: "resultats_preoperatoires",
                label: 'Résultats preopératoires',
                type: 'textarea',
            },
            {
                id: "diagnostique_apres_la_chirurgie_de_revision",
                label: 'Diagnostique après la chirurgie de révision',
                type: 'textarea',
            },
        ]
    },
]
